import { catalogDataColumns, categoryGroupsFor, gridLayout } from "./catalogColumns";

const PLAN_IDENTITY_COLUMNS = [
    {
        key: "clientName",
        label: "Client",
        category: "General",
        frozen: true,
        width: 200,
        value: (plan) => plan.client?.displayName ?? null,
    },
    {
        key: "planId",
        label: "Plan ID",
        category: "General",
        frozen: true,
        width: 160,
        value: (plan) => plan.planId ?? null,
    },
    {
        key: "displayName",
        label: "Plan Name",
        category: "General",
        frozen: false,
        width: 180,
        value: (plan) => plan.displayName ?? null,
    },
    {
        key: "status",
        label: "Status",
        category: "General",
        frozen: false,
        width: 120,
        value: (plan) => plan.status ?? null,
    },
];

const planGridLayout = (fields, extraFrozen = []) => {
    const columns = [...PLAN_IDENTITY_COLUMNS, ...catalogDataColumns(fields)];
    const frozen = [...PLAN_IDENTITY_COLUMNS.filter((column) => column.frozen), ...extraFrozen];
    return {
        columns,
        ...gridLayout(frozen, categoryGroupsFor(columns)),
    };
};

export { PLAN_IDENTITY_COLUMNS, planGridLayout };
